import React from 'react';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import DatePickerField from '../shared/DatePickerField';
import { setForm as setDefaultValues } from '../../reducers/booksRequestFilter';

const initialSortDatesFormValues = {
  selectFrom: new Date().setDate(new Date().getDate() - 30),
  selectTo: new Date().setDate(new Date().getDate()),
}

let BookRequestFilter = ({ setForm, handleSubmit }) => {
  setForm(initialSortDatesFormValues);

  return (
    <form className="dates-filter d-flex align-items-center" onSubmit={handleSubmit}>
      <span>C:</span>
      <DatePickerField name="selectFrom" />
      <span>По:</span>
      <DatePickerField name="selectTo" />
      <button type="submit" className="btn">Найти</button>
    </form>
  );
}

BookRequestFilter = connect(
  (state, props) => ({
    form: `bookRequestFilter${props.formName}`,
    initialValues: state.booksRequestFilter.data,
  }),
  { setForm: setDefaultValues },
)(reduxForm()(BookRequestFilter));


export default BookRequestFilter;
